export const GET_PUSH_NOTIFICATIONS_LOGS_REQUEST = "GET_PUSH_NOTIFICATIONS_LOGS_REQUEST";
export const GET_PUSH_NOTIFICATIONS_LOGS_SUCCESS = "GET_PUSH_NOTIFICATIONS_LOGS_SUCCESS";
export const GET_PUSH_NOTIFICATIONS_LOGS_FAILURE = "GET_PUSH_NOTIFICATIONS_LOGS_FAILURE";
